import BabyButton from '~/components/scales/BabyButton/BabyButton';
import Icon from '~/components/scales/Icon/Icon';

export default function ClearIconButton(props: { onClick: () => void }) {
  return <BabyButton aria-label="clear" icon={<Icon name="close" />} onClick={props.onClick} />;
}
